import * as types from './mutation-types'
import api from '../../../api'
import {tryDefaultValue} from '../../../utils/commons'
// 定义初始化默认状态
const state = {
  // jumpSchools: [
  //   {
  //     id: '99',
  //     name: '温州商学院'
  //   },
  //   {
  //     id: '110',
  //     name: '宁波大学科学技术学院'
  //   },
  //   {
  //     id: '50',
  //     name: '宁波财经学院'
  //   },
  //   {
  //     id: '60',
  //     name: '浙江中医药大学'
  //   },
  //   {
  //     id: '30',
  //     name: '杭州师范大学钱江学院'
  //   },
  //   {
  //     id: '22',
  //     name: '浙江大学城市学院'
  //   },
  //   {
  //     id: '49',
  //     name: '浙江工业大学'
  //   },
  //   {
  //     id: '112',
  //     name: '杭州电子科技大学'
  //   },
  //   {
  //     id: '118',
  //     name: '浙江工商大学'
  //   },
  //   {
  //     id: '70',
  //     name: '浙江工业大学之江学院'
  //   },
  //   {
  //     id: '116',
  //     name: '宁波工程学院'
  //   }
  // ],
  account: {user_id: '', token: ''},
  isLogin: false,
  toast: {show: false, type: '', content: ''},
  college: {},
  instance: {},
  enrollPlanTab: {},
  enrollPlanData: {},
  expert: {},
  expertList: [],
  expertQuestionList: [],
  userQuestionList: [],
  enrollPlan: [],
  enrollResult: [],
  enrollResultTab: {},
  enrollResultData: {},
  resource: [],
  resourceDetail: '',
  commonProblem: [],
  order: [],
  currentId: 0,
  instanceTitle: '',
  majorDetail: {},
  weixin: {},
  html: '',
  ipAddress: {},
  miniProgram: {},
  banner: null
}
// 读取缓存的登录状态判断是否过期
if (window.localStorage.USER_MOBILE && window.localStorage.USER_EXPIRATION_DATE_MOBILE) {
  if ((new Date()).getTime() < JSON.parse(window.localStorage.USER_EXPIRATION_DATE_MOBILE)) {
    state.account = JSON.parse(window.localStorage.USER_MOBILE)
    state.isLogin = true
  } else {
    state.account = {user_id: '', token: ''}
    delete window.localStorage.USER_MOBILE
    delete window.localStorage.USER_EXPIRATION_DATE_MOBILE
  }
}

const getters = {
  jumpSchools: state => state.jumpSchools,
  ipAddress: state => state.ipAddress,
  account: state => state.account,
  isLogin: state => state.isLogin,
  toast: state => state.toast,
  college: state => state.college,
  instance: state => state.instance,
  enrollPlanTab: state => state.enrollPlanTab,
  enrollPlanData: state => state.enrollPlanData,
  expert: state => state.expert,
  expertList: state => state.expertList,
  expertQuestionList: state => state.expertQuestionList,
  userQuestionList: state => state.userQuestionList,
  enrollPlan: state => state.enrollPlan,
  enrollResult: state => state.enrollResult,
  enrollResultTab: state => state.enrollResultTab,
  enrollResultData: state => state.enrollResultData,
  resource: state => state.resource,
  resourceDetail: state => state.resourceDetail,
  commonProblem: state => state.commonProblem,
  order: state => state.order,
  currentId: state => state.currentId,
  instanceTitle: state => state.instanceTitle,
  majorDetail: state => state.majorDetail,
  weixin: state => state.weixin,
  html: state => state.html,
  miniProgram: state => state.miniProgram,
  banner: state => state.banner
}

const mutations = {
  // 从三位一体过来模拟登录
  [types.LOGIN_SUCCEED_FROMSWYT] (state, data) {
    state.account.user_id = data.user_id
    state.account.token = data.token
    console.log('swytaccount' + data.token)
    state.isLogin = true
    // 登录状态缓存
    window.localStorage.USER_MOBILE = JSON.stringify(state.account)
    window.localStorage.USER_EXPIRATION_DATE_MOBILE = JSON.stringify((new Date()).getTime() + 7 * 24 * 3600 * 1000)
    return data
    // state.account = data
  },
  [types.LOGIN_SUCCEED] (state, data) {
    state.account = data
    console.log('account' + data)
    state.isLogin = true
    // 登录状态缓存
    window.localStorage.USER_MOBILE = JSON.stringify(state.account)
    window.localStorage.USER_EXPIRATION_DATE_MOBILE = JSON.stringify((new Date()).getTime() + 7 * 24 * 3600 * 1000)
  },
  [types.LOGIN_FAILED] () {
    state.isLogin = false
    state.account = {}
    delete window.localStorage.USER_MOBILE
    delete window.localStorage.USER_EXPIRATION_DATE_MOBILE
  },
  [types.SHOW_TOAST] (state, data) {
    state.toast = data
  },
  [types.HIDE_TOAST] (state) {
    state.toast.show = false
  },
  // 3,突变改变默认state
  [types.FETCH_COLLEGE_INFO]  (state, json) {
    let data = json
    if (!data.primaryColor) {
      data.primaryColor = '#498fc1'
    }
    state.college = data
    console.log('FETCH_COLLEGE_INFO', state.college)
  },
  [types.FETCH_INSTANCE_INFO] (state, json) {
    state.instance = json
  },
  [types.FETCH_INSTANCE_TITLE] (state, json) {
    state.instanceTitle = json
  },
  [types.FETCH_ENROLLPLAN_TAB] (state, data) {
    state.enrollPlanTab = data
  },
  [types.FETCH_ENROLLPLAN_DATA] (state, data) {
    state.enrollPlanData = data
  },
  [types.FETCH_ENROLLRESULT_TAB] (state, data) {
    state.enrollResultTab = data
  },
  [types.FETCH_ENROLLRESULT_DATA] (state, data) {
    state.enrollResultData = data
  },
  [types.FETCH_EXPERT_INFO] (state, data) {
    state.expert = data
  },
  [types.FETCH_EXPERT_LIST] (state, data) {
    state.expertList = data
  },
  [types.FETCH_EXPERT_QUESTION] (state, data) {
    state.expertQuestionList = data
  },
  [types.FETCH_USER_QUESTION] (state, json) {
    state.userQuestionList = json
  },
  // SUBMIT_QUESTION (state, json) {
  //   state.submitQuestion = json
  // }
  [types.FETCH_ENROLLPLAN] (state, json) {
    state.enrollPlan = json
  },
  [types.FETCH_ENROLLRESULT] (state, json) {
    state.enrollResult = json
  },
  [types.FETCH_RESOURCE] (state, data) {
    state.resource = data
  },
  [types.FETCH_RESOURCE_DETAIL] (state, data) {
    state.resourceDetail = data
  },
  [types.FETCH_COMMON_PROLEM] (state, json) {
    state.commonProblem = json
  },
  // 分发订单
  [types.CONFIRM_ORDER] (state, json) {
    state.order = json
  },
  // 存取当前选中tab 的index
  [types.CUEEENT_TAB] (state, index) {
    state.currentId = index
  },
  [types.FETCH_MAJOR] (state, data) {
    state.majorDetail = data
  },
  [types.GET_WEIXIN] (state, data) {
    state.weixin = data
  },
  [types.GET_HTML] (state, data) {
    state.html = data
  },
  [types.SET_IP_ADDRESS] (state, data) {
    state.ipAddress = data
  },
  [types.GET_MINI_PROGRAM] (state, data) {
    state.miniProgram = data
  },
  [types.SET_BANNER] (state, data) {
    console.log('SET_BANNER', data, state.instance, state.college)
    if ([1, 16, 17, 19, 20, 23, 24, 14].includes(state.college.indexClassID)) {
      if (data !== undefined) {
        state.banner = data
      }
    }
  }
}

const actions = {
  async getIp ({commit}) {
    const {data = {}} = await api.getIp()
    if (data.code === 0) {
      commit(types.SET_IP_ADDRESS, data.data)
    }
    return data
  },
  async fetchCollegeInfo ({commit}, query) {
    const {data = {}} = await api.fetch_college_info(query)
    if (data.code === 200) {
      commit(types.FETCH_COLLEGE_INFO, data.data)
    }
    return data
  },
  async fetchInstanceInfo ({commit}, query) {
    const {data = {}} = await api.fetch_instance_info(query)
    if (data.code === 200) {
      commit(types.FETCH_INSTANCE_INFO, tryDefaultValue(() => JSON.parse(data.data.json), {})) // 将请求数据json 传递给突变
      commit(types.FETCH_INSTANCE_TITLE, data.data.title)
      console.log('JSON.parse(data.data.json)', JSON.parse(data.data.json))
      const json = JSON.parse(data.data.json)
      // console.log('xxx', json.banner == undefined, !isEmpty(json.banner))

      commit(types.SET_BANNER, json.banner)
    }
    return data
  },
  // 公共方法
  _showMsg ({commit}, {content, type}) {
    commit(types.SHOW_TOAST, {show: true, content: content, type: type})
    setTimeout(() => commit(types.HIDE_TOAST), 2000)
  },
  // 存取当前选中tab
  fetchCurrentTab ({commit}, data) {
    commit(types.CUEEENT_TAB, data)
    return data
  },
  // 从三位一体过来的用户模拟登录成功
  loginFromSWYT ({commit}, data) {
    commit(types.LOGIN_SUCCEED_FROMSWYT, data)
    return data
  },
  // logger
  async logger ({commit}, query) {
    const {data = {}} = await api.logger({
      string: query.name + '#' + new Date().toLocaleString(),
      biz: query.biz
    })
    return data
  },
  async login ({dispatch, commit}, query) {
    const {data = {}} = await api.login(query)
    console.log('loain', data)
    if (data.code === 200) {
      commit(types.LOGIN_SUCCEED, data.data)
      dispatch('_showMsg', ({commit}, '登录成功'))
      window.location.replace(window.location.href)
    } else if (data.code === 405) {
      commit(types.LOGIN_FAILED)
      dispatch('_showMsg', ({commit}, '登录失败', 'cancel'))
      // this._showMsg({commit}, '登录失败', 'cancel')
    }
  },
  async fetchResource ({commit}, query) {
    console.log('nb', query)
    const {data = {}} = await api.fetch_resource(query)
    if (data.code === 200) {
      commit(types.FETCH_RESOURCE, data.data)
    }
    return data
  },
  async fetchVcode ({dispatch, commit}, query) {
    const {data = {}} = await api.send_sms(query)
    if (data.code === 200) {
      dispatch('_showMsg', {content: '请在手机上查看验证码'})
    } else {
      dispatch('_showMsg', {content: '获取失败', type: 'cancel'})
    }
    return data
  },
  async fetchExpertList ({commit}, query) {
    const {data = {}} = await api.fetch_expert_list(query)
    if (data.code === 200) {
      commit(types.FETCH_EXPERT_LIST, data.data.list)
    }
    return data
  },
  async fetchExpertInfo ({commit}, query) {
    try {
      const {data = {}} = await api.fetch_expert_info(query)
      if (data.code === 200) {
        commit(types.FETCH_EXPERT_INFO, data.data.result)
      }
      return data
    } catch (e) {
      commit(types.LOGIN_FAILED)
    }
  },
  async fetchExpertQuestion ({commit}, query) {
    const {data = {}} = await api.fetch_expert_question(query)
    if (data.code === 200) {
      commit(types.FETCH_EXPERT_QUESTION, data.data.questions_list)
    }
    return data
  },
  async fetchUserQuestion ({commit}, query) {
    const {data = {}} = await api.fetch_user_question(query)
    const json = data.json()
    if (json.code === 200) {
      commit(types.FETCH_USER_QUESTION, json.data.questions_list)
    }
    return data
  },
  async fetchEnrollPlan ({commit}, query) {
    const {data = {}} = await api.fetch_enrollPlan(query)
    if (data.code === 200) {
      commit(types.FETCH_ENROLLPLAN, data.data.list)
    }
    return data
  },
  async fetchEnrollPlanTab ({commit}, query) {
    const {data = {}} = await api.fetch_enrollPlan_tab(query)
    if (data.code === 200) {
      commit(types.FETCH_ENROLLPLAN_TAB, data.data)
    }
    return data
  },
  async fetchEnrollPlanData ({commit}, query) {
    const {data = {}} = await api.fetch_enrollPlan_data(query)
    if (data.code === 200) {
      commit(types.FETCH_ENROLLPLAN_DATA, data.data)
    }
    return data
  },
  async fetchEnrollResult ({commit}, query) {
    const {data = {}} = await api.fetch_enrollResult(query)
    if (data.code === 200) {
      commit(types.FETCH_ENROLLRESULT, data.data.list)
    }
    return data
  },
  async fetchEnrollResultTab ({commit}, query) {
    const {data = {}} = await api.fetch_enrollResult_tab(query)
    if (data.code === 200) {
      commit(types.FETCH_ENROLLRESULT_TAB, data.data)
    }
    return data
  },
  async fetchEnrollResultData ({commit}, query) {
    const {data = {}} = await api.fetch_enrollResult_data(query)
    if (data.code === 200) {
      commit(types.FETCH_ENROLLRESULT_DATA, data.data)
    }
    return data
  },
  async fetchResourceDetail ({commit}, query) {
    const {data = {}} = await api.fetch_resource_detail(query)
    if (data.code === 200) {
      commit(types.FETCH_RESOURCE_DETAIL, data.data)
    }
    return data
  },
  async fetchCommonProblem ({commit}, query) {
    const {data = {}} = api.fetch_common_problem(query)
    const json = data.json()
    if (json.code === 200) {
      commit(types.FETCH_COMMON_PROLEM, json.data.list)
    }
    return data
  },
  async fetchMajor ({commit}, query) {
    const {data = {}} = await api.fetch_major(query)
    commit(types.FETCH_MAJOR, data)
    console.log('FETCH_MAJOR', data)
    return data
  },
  async getWeixin ({commit}, query) {
    const {data = {}} = await api.get_weixin(query)
    commit(types.GET_WEIXIN, data)
    return data
  },
  async getHtml ({commit}, url) {
    const {data = {}} = await api.getHtml(url)
    commit(types.GET_HTML, data)
    return data
  },
  async getMiniProgram ({commit}, query) {
    const {data = {}} = await api.getMiniProgram(query)
    if (data.code === 200) {
      commit(types.GET_MINI_PROGRAM, data.result)
    }
    return data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common/index.js